module.exports = __webpack_public_path__ + "img/25.b2a46774.jpeg";